import { useEffect, useState } from "react";
import Sidebar from "@/components/Sidebar";
import BottomNav from "@/components/BottomNav";
import MobileTopBar from "@/components/MobileTopBar";
import QuickFlow from "@/components/QuickFlow";
import { track } from "@/lib/productTelemetry";

/**
 * El flujo de «anotar algo» se monta UNA vez, aquí.
 *
 * Cualquier pantalla lo abre con `window.dispatchEvent(new CustomEvent("td:quick"))`
 * —opcionalmente con `detail: "expense" | "income" | "move" | "pay"` para saltar
 * directo a un verbo— y cuando se guarda algo se emite `td:data-changed`, que es
 * la señal para que la pantalla visible recargue. Así el botón «+» funciona igual
 * en todas partes sin que cada página monte su propio diálogo.
 */
export default function Layout({ children }) {
  const [flow, setFlow] = useState(null);

  useEffect(() => {
    const open = (e) => {
      // Aquí pasa TODO el «anotar algo», venga del «+» o de un atajo de otra
      // pantalla. Es el único sitio donde contarlo una sola vez.
      track("plus_opened", { screen: "quickflow" });
      setFlow(e.detail || "menu");
    };
    window.addEventListener("td:quick", open);
    return () => window.removeEventListener("td:quick", open);
  }, []);

  return (
    <div className="min-h-screen bg-[#0b0a10] text-white overflow-x-clip">
      <Sidebar />
      <main className="lg:ml-64 min-h-screen overflow-x-clip">
        <div className="px-4 sm:px-6 lg:px-10 pt-0 lg:pt-6 pb-32 lg:pb-12 max-w-[900px] overflow-x-clip">
          <MobileTopBar />
          {children}
        </div>
      </main>
      <BottomNav />

      <QuickFlow
        open={flow !== null}
        onOpenChange={(v) => !v && setFlow(null)}
        initialVerb={flow === "menu" ? null : flow}
        onDone={() => window.dispatchEvent(new CustomEvent("td:data-changed"))}
      />
    </div>
  );
}
